import {showNotification} from "@mantine/notifications";
import {signInWithRedirect} from "aws-amplify/auth";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";


export const showErrorNotifications = (e: unknown) => {

    console.debug('handleAppSyncResponseException', e)

    if (typeof (e as { errors?: { message: string }[] }).errors !== 'undefined' && ((e as { errors?: { message: string }[] }).errors?.length ?? 0) > 0) {
        ((e as { errors?: { message: string }[] }).errors ?? []).forEach((error: { message: string; }) => {
            showErrorNotification(error.message);
        })
    }
}


export const showSuccessNotification = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const showErrorNotification = (message = 'Error performing the operation') => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifyError = (e: unknown) => {

    console.trace(e);

    const message = (e instanceof Error ? e.message : typeof e === 'object' && e !== null && 'message' in e ? String((e as { message: unknown }).message) : null) || 'Error performing the operation'

    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        notifySessionExpired();
    }

}

export const notifySessionExpired = (message = 'Redirecting to login page... Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });

    setTimeout(() => {
        // window.location.reload();
        signInWithRedirect();
    }, 1000);

};

// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}
